import { Component } from '@angular/core';

import { LoadingController, ModalController } from 'ionic-angular';
import { AlertMessager } from '../../../../lib/alertMessager';
import { RodeoService } from '../../../../services/rodeo.service';
import { DrawResults } from '../../../../pages/rodeo/draw-results';

@Component({
    selector: 'admin-draw',
    templateUrl: 'draw.html'
})
export class DrawSection {
    popoverActive: boolean;
    dataLoading: boolean;

    drawResults: DrawResults;

    constructor(private rodeoService: RodeoService, private alert: AlertMessager, private modalCtrl: ModalController,  private loadingControl: LoadingController) { 
    }

    undrawRodeos(orgId: number) {
        if (this.popoverActive)
            return;

        this.popoverActive = true;
        let loader = this.loadingControl.create({
            content: 'Undoing draw...',
        });

        loader.present();

        this.rodeoService.undoOrgDraw(orgId)
        .then(() => {
            loader.dismiss();
            this.popoverActive = false;
            this.alert.showConfirmation("Draw Undo Status", "Draw undone successfully!");
        }).catch(() => {
            loader.dismiss();
            this.popoverActive = false;
        })
    }

    drawRodeos(orgId: number) {
        if (this.popoverActive)
            return;

        let loader = this.loadingControl.create({
            content: 'Drawing rodeos....'
        });

        loader.present();

        this.popoverActive = true;
        this.rodeoService.drawOrgRodeos(orgId)
        .then(data => {
            let entryModal = this.modalCtrl.create(DrawResults, { results: data}, { cssClass: 'page-draw-results', enableBackdropDismiss: false });

            entryModal.present();
            entryModal.onDidDismiss((data) =>{
                this.popoverActive = false;
            });
            loader.dismiss();
        }, error => { 
            console.log(error); this.alert.showError('Error', 'Unable to draw rodeos.') 
            loader.dismiss();
            this.popoverActive = false;
        });
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/admin/draw/draw.ts